// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"alertWrapper--4c4fa"};